/* eslint-disable max-len */
import React from 'react';

export const BagHandleSpot = (): React.ReactElement => (
  <svg
    fill="none"
    height="48"
    viewBox="0 0 49 48"
    width="49"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5895_28912)">
      <circle cx="24.4628" cy="24" fill="#F7F5F0" r="24" />
    </g>
    <path
      d="M13.0945 33.9395V16.8202C13.0945 16.8202 12.7173 15.1373 15.822 15.1663C18.9267 15.1953 32.9413 15.1663 32.9413 15.1663C32.9413 15.1663 35.1465 14.9922 35.1465 17.7197C35.1465 20.4472 35.1465 33.7944 35.1465 33.7944C35.1465 33.7944 35.1465 35.7675 33.1154 35.7965C31.0843 35.8255 14.8064 35.7965 14.8064 35.7965C14.8064 35.7965 13.0945 35.7095 13.0945 33.9395Z"
      fill="#1072EB"
    />
    <path
      d="M13.0945 35.1299V18.0106C13.0945 18.0106 12.7173 16.3277 15.822 16.3567C18.9267 16.3857 32.9413 16.3567 32.9413 16.3567C32.9413 16.3567 35.1465 16.1826 35.1465 18.9101C35.1465 21.6376 35.1465 34.9849 35.1465 34.9849C35.1465 34.9849 35.1465 36.9579 33.1154 36.9869C31.0843 37.016 14.8064 36.9869 14.8064 36.9869C14.8064 36.9869 13.0945 36.8999 13.0945 35.1299Z"
      fill="#37A5F6"
    />
    <mask
      height="21"
      id="mask0_5895_28912"
      maskUnits="userSpaceOnUse"
      style={{ maskType: 'alpha' }}
      width="23"
      x="13"
      y="16"
    >
      <path
        d="M13.0945 35.1299V18.0106C13.0945 18.0106 12.7173 16.3277 15.822 16.3567C18.9267 16.3857 32.9413 16.3567 32.9413 16.3567C32.9413 16.3567 35.1465 16.1826 35.1465 18.9101C35.1465 21.6376 35.1465 34.9849 35.1465 34.9849C35.1465 34.9849 35.1465 36.9579 33.1154 36.9869C31.0843 37.016 14.8064 36.9869 14.8064 36.9869C14.8064 36.9869 13.0945 36.8999 13.0945 35.1299Z"
        fill="#38AF88"
      />
    </mask>
    <g mask="url(#mask0_5895_28912)">
      <path
        d="M11.2054 26.8405L15.5021 24.2666L19.3934 36.9944H11.2054V26.8405Z"
        fill="#1072EB"
      />
    </g>
    <path
      d="M24.0914 8C18.3173 8 18.4043 13.542 18.4043 13.542V16.3565H19.5069V13.8902C19.5069 13.8902 19.4489 9.01555 24.0334 9.01555C28.6179 9.01555 28.5889 13.7161 28.5889 13.7161V16.3565H29.8075V13.3679C29.8075 13.3679 29.8656 8 24.0914 8Z"
      fill="#909191"
    />
    <path
      d="M24.0914 30.1098C26.1106 30.1098 27.7474 28.473 27.7474 26.4538C27.7474 24.4347 26.1106 22.7979 24.0914 22.7979C22.0723 22.7979 20.4354 24.4347 20.4354 26.4538C20.4354 28.473 22.0723 30.1098 24.0914 30.1098Z"
      fill="#F7F5F0"
    />
    <defs>
      <clipPath id="clip0_5895_28912">
        <rect
          fill="white"
          height="48"
          transform="translate(0.462772)"
          width="48"
        />
      </clipPath>
    </defs>
  </svg>
);
